<template>
  <v-dialog
    :color="$app.opts.modalHeaderColor"
    :value="visible"
    @keydown.esc="close(noEsc)"
    @input="(v) => v || close()"
    scrollable
    :max-width="size"
    persistent
  >
    <VWidget
      :enable-footer-actions="!this.noActions"
      :footer-separator="!noSeparator"
      :content-class="contentClass"
      :loading="loading"
      opaque-loading
    >
      <template slot="title">
        <slot name="title">Title</slot>
      </template>

      <template slot="header-actions">
        <slot name="header-actions"></slot>
        <v-btn icon small @click="close()" v-if="dismiss">
          <v-icon small>{{ $vuetify.icons.values.close }}</v-icon>
        </v-btn>
      </template>

      <template slot="alert">
        <slot name="alert" />
      </template>

      <template slot="content">
        <slot name="content"></slot>
      </template>

      <template slot="footer-actions">
        <slot name="footer-actions">
          <v-btn depressed color="accent" @click="submit" v-if="submit" :loading="submitting" :disabled="submitting">
            {{ buttonTitle }}
          </v-btn>
        </slot>
      </template>
    </VWidget>
  </v-dialog>
</template>

<script>
import VWidget from './VWidget'

export default {
  name: 'VModalWidget',
  components: {
    VWidget
  },
  props: {
    submit: { type: Function },
    dismiss: { type: Function },
    submitting: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    visible: { type: Boolean, default: true },
    noEsc: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    contentClass: { type: String, default: 'pa-4' },
    noActions: { type: Boolean, default: false },
    noSeparator: { type: Boolean, default: false },
    submitTitle: { type: String, required: false, default: '' }
  },
  computed: {
    size() {
      if (this.large) {
        return this.$app.opts.modalSizeLarge
      }
      if (this.medium) {
        return this.$app.opts.modalSizeMedium
      }
      if (this.small) {
        return this.$app.opts.modalSizeSmall
      }
      return this.$app.opts.modalSizeDefault
    },
    buttonTitle() {
      if (this.submitTitle) {
        return this.submitTitle
      } else {
        return this.$t('submit')
      }
    }
  },
  methods: {
    close(noEsc) {
      let shouldClose = !!this.dismiss && !noEsc
      if (shouldClose) {
        return this.dismiss()
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "submit": "@:labels.submit"
  },
  "fr": {
    "submit": "@:labels.submit"
  }
}
</i18n>
